export enum INVOICE_STEP_BULK_FIELDS {
  UNIQUE_BULK_REQUEST_NUMBER = 'Unique Bulk Request Number',
  TYPE = 'Type (Credit/ Debit)',
  TRANSACTION_TYPE = 'Transaction Type',
  VAT_SVAT = 'Vat/ Svat',
  POLICY_TYPE = 'Policy Type (Local/ Fronting)',
  POLICY_NUMBER = 'Policy Number',
  POLICY_START_DATE = 'Policy Start Date',
  POLICY_END_DATE = 'Policy End Date',
  INVOICE_NUMBER = 'Invoice Number',
  DATE_OF_ISSUE = 'Date Of Issue',
  TYPE_OF_PRODUCT = 'Type of Product',
  CURRENCY_TYPE = 'Currency Type',
  CONVERSION_RATE = 'Conversion Rate',
  PAID_DATE = 'Paid Date',
  PAID_CONVERSION_RATE = 'Paid Conversion Rate',
}

export enum INVOICE_PREMIUM_BULK_FIELDS {
  SUM_ASSURED = 'Sum Assured',
  BASIC = 'Basic',
  SRCC = 'Srcc',
  TC = 'Tc',
  DISCOUNT = 'Discount',
  FEES_AND_CHARGERS = 'Fees And Chargers',
  AMOUNT = 'Amount',
}

export enum INVOICE_COMMISSION_BULK_FILDS {
  TOTAL_PREMIUM = 'Total Premium',
  COMMISSION_TYPE = 'Commission Type',
  COMMISSION_BASIC = 'Commission For Basic',
  COMMISSION_SRCC = 'Commission For SRCC',
  COMMISSION_TC = 'Commission For TC',
  FEE = 'Fee',
  TOTAL_RECEIVABLE_COMMISSION = 'Total Receivable / Refundable Commission',
  ADDITIONAL_AGENT_CODE = 'Additional Agent Code',
  COMMISSION_AMOUNT = 'Commission Amount',
  AGENT_CODE = 'Agent Code',
  AGENT_AMOUNT = 'Agent Commission Amount',
  EXTERNAL_AGENT_CODE = 'External Agent Code',
  EXTERNAL_AGENT_AAMOUNT = 'External Agent Amount',
}

export enum INVOICE_RECEIPT_BULK_FILDS {
  RECEIPT_PAID_AMOUNT = 'Receipt Paid Amount',
  RECEIPT_PAID_DATE = 'Receipt Paid Date',
  RECEIPT_PAY_TO = 'Receipt Pay To',
}

export enum ERROR_TYPES {
  REQUIRED = 'required',
  FEES_ISSUE = 'fees_and_chargers',
  RECEIPT_FIELDS_ISSUES = 'receipt_filed_issues',
  AMOUNT_ISSUE = 'amount',
  CREDIT_DEBIT_ISSUE = 'type_credit_debit',
  TRANSACTION_TYPE = 'transaction_type',
  PO_TYPE = 'policy_type_local_fronting',
  INVALID_CURRENCY_TYPE = 'currency_type',
  INVALID_EXTERNAL_AGENT = 'external_agent_code',
  INVALID_ADDITIONAL_AGENT = 'Invalid Additional Agent code',
  INVALID_MARKETING_AGENT = 'agent_code',
  INVALID_POLICY_NUMBER = 'additional_agent_code',
  INVALID_SOURCE_OF_LEAD = 'source_of_lead',
  UNIQUE_ISSUE = 'unique_bulk_request_number',
  SVAT_VAT_ISSUE = ' vat_svat ',
  LEAD_TYPES_ERROR = 'group_or_individual',
  INVALID_INSURANCE_TYPES = 'insurance_type',
  INVALID_COVERAGE = 'coverage',
  INVALID_ACCOUNT_HOLDER = 'account_handler',
  INVALID_CLAIM_HANDLER = 'claim_handler',
  ERROR_IN_ADDITIONAL_COVERS = 'additional_covers',
  MISMATCHED_ADDITIONAL_COVER_KEYS = 'additional_covers_mismatch',
  INVALID_ADDITIONAL_COVER_PREFIX = 'additional_covers_prefix',
  INVALID_PRODUCT = 'product',
  INVALID_INSURER = 'insurer',
  INVALID_EMAIL = 'email',
  INVALID_COUNTRY = 'country',
  INVALID_STATE = 'state',
  INVALID_DISTRICT = 'district',
  INVALID_CITY = 'city',
}

export enum TOGGLE_VALUES {
  ALL = 'all',
  VALID = 'valid',
  INVALID = 'invalid',
}
